import React from 'react';
import {useFormContext, Controller, useWatch} from 'react-hook-form';
import PropTypes from 'prop-types';
import Select from 'react-select';
import {t} from 'react-switch-lang';
import {Tooltip} from 'antd';

const SelectList = ({
                      name,
                      options,
                      className,
                      isDisabled,
                      selectedItem,
                      placeholder,
                      defaultValue = null,
                      showTooltip = false,
                        style,
                      ...rest
                    }) => {
  if (!useFormContext())
    throw new Error('Smart component must be in "Form" wrapper component!');
  if (!name) {
    throw new Error('"name" field is required for SelectList component');
  }
  if (!options) {
    throw new Error(
      '"options" field is required for SelectList component'
    );
  }

  const {control, errors} = useFormContext();
  const selected = useWatch({ control, name });

  return (
    <Tooltip title={showTooltip && selected?.label ? selected.label : ''} placement="right">
      <div>
        <Controller
        control={control}
        name={name}
        as={Select}
        options={options}
        className={`${className} ${errors[name] && ' error-field'}`}
        components={{IndicatorSeparator: () => null}}
        isClearable={true}
        isDisabled={isDisabled}
        isSearchable={true}
        placeholder={placeholder}
        defaultValue={defaultValue}
        styles={style}
        noOptionsMessage={() => t('common.noOption') }
        {...rest}
      />
      {errors[name] && (
        <span className="error-message">{errors[name].message}</span>
      )}
    </div>
    </Tooltip>
  );
};

export default SelectList;

SelectList.propTypes = {
  name: PropTypes.string.isRequired,
  options: PropTypes.array
};